import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { ProductSection } from '../components/sales/ProductSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { PricingSection } from '../components/sales/PricingSection';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#050505] text-[#f0f0f0] font-sans selection:bg-[#00d4aa] selection:text-black" data-id="element-134">
      <HeroSection data-id="element-135" />
      <ProblemSection data-id="element-136" />
      <ProductSection data-id="element-137" />
      <TestimonialsSection data-id="element-138" />
      <MechanismSection data-id="element-139" />
      <AudienceSection data-id="element-140" />
      <PricingSection data-id="element-141" />

      <footer className="py-12 text-center text-gray-600 text-sm bg-[#050505] border-t border-gray-900 space-y-6 px-6" data-id="element-142">
        <p data-id="element-143">
          © {new Date().getFullYear()} EBOOK CREATOR. Todos los derechos
          reservados.
        </p>
        <div className="max-w-2xl mx-auto text-xs text-gray-700 space-y-4 leading-relaxed" data-id="element-144">
          <h4 className="text-gray-500 font-semibold uppercase tracking-wider text-[11px]" data-id="element-145">
            Términos y Condiciones
          </h4>
          <p data-id="element-146">
            Al adquirir EBOOK CREATOR, aceptas los siguientes términos: Este
            producto es un recurso digital (GPT + videos) de acceso inmediato.
            No se garantizan resultados específicos de ventas, ya que estos
            dependen de la ejecución individual del comprador.
          </p>
          <p data-id="element-147">
            <strong className="text-gray-500" data-id="element-148">Política de reembolso:</strong>{' '}
            Dispones de 7 días desde la fecha de compra para solicitar un
            reembolso completo según nuestras políticas de devolución, sin
            necesidad de justificación.
          </p>
          <p data-id="element-149">
            <strong className="text-gray-500" data-id="element-150">Propiedad intelectual:</strong>{' '}
            Todo el contenido incluido (prompts, videos, guías y plantillas) es
            propiedad de Mauricio Medina. Queda prohibida su redistribución,
            reventa o reproducción total o parcial sin autorización expresa.
          </p>
          <p data-id="element-151">
            <strong className="text-gray-500" data-id="element-152">Uso del producto:</strong> La
            licencia es personal e intransferible. El acceso es individual y no
            puede compartirse con terceros.
          </p>
          <p data-id="element-153">
            <strong className="text-gray-500" data-id="element-154">Contacto:</strong> Para consultas
            o soporte, comunícate por correo electrónico.
          </p>
          <p data-id="element-155">
            Al completar tu compra, confirmas que has leído y aceptado estos
            términos.
          </p>
        </div>
      </footer>
    </main>;
}